// extracted by mini-css-extract-plugin
export default {"action":"AvatarEditStep_action__uLlR3","actionButton":"AvatarEditStep_actionButton__TsBby"};